import { render, staticRenderFns } from "./toast-alert-sla.vue?vue&type=template&id=72574f28&scoped=true&"
import script from "./toast-alert-sla.vue?vue&type=script&lang=js&"
export * from "./toast-alert-sla.vue?vue&type=script&lang=js&"
import style0 from "./toast-alert-sla.vue?vue&type=style&index=0&id=72574f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72574f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
